// TODO validate inside components: [society-dashboard, partners-book]

import superAdmins from 'constants/superAdmins';

const superAdminIds = [
  'admin-center',
  'employees-plan-list',
  'employees-notifications-list',
];

const adminOrPartnerOrRepresentantValidationIds = ['society-dashboard'];

const adminOrPartnerValidationIds = [
  'partners-list',
  'partner-cards',
  'partners-list-user',
  'partners-book',
  'board-details',
  'signature-delegation',
  'portfolio-cards',
  'portfolio-list-filter',
  'portfolio-cards-filter',
  'portfolio-list',
  'portfolio-chart',
];

const adminOrBeneficiaryValidationIds = [
  'beneficiary-list',
  'beneficiary-cards',
  'beneficiary-plan',
];

const adminOrInvestorValidationIds = ['investors-list'];

const adminValidationIds = [
  'annual-value',
  'beneficiary-drafts-plan',
  'beneficiary-drafts',
  'boards-list',
  'director-details',
  'drafts-increase-id',
  'drafts-increase',
  'drafts-note-id',
  'drafts-note',
  'drafts-safe-id',
  'drafts-safe',
  'drafts-sell-id',
  'drafts-sell',
  'drafts-society',
  'employee-list',
  'employee-details',
  'holding-classes',
  'partner-representant-details',
  'partners-categories',
  'partners-representants',
  'representative-details',
  'signatures-details',
  'signatures-list',
  'society-ai-agent',
  'stockplans-society',
  'summary-plans',
  'templates',
  'tender-offers-details',
  'tender-offers-list',
  'transaction-details',
  'transactions-society',
  'share-details-page',
  'encumbranbce-details-page',
  'encumbranbce-details-page-historical',
];

const otherAdminIds = [
  'documents-docs',
  'documents-new',
  'documents-recents',
  'documents-minutebook',
  'documents-writings',
  'documents-certificates',
  'documents-letters',
  'documents-signs',
  'documents-assignments',
  'documents-authority',
  'documents-annualreports',
  'documents-templates-all',
  'documents-templates-new',
  'documents-deleted',
  'documents-society',
  'documents',
  'society-profile',
];

const partnerValidationIds = [
  'transactions-society-partner',
  'partner-details',
  'partner-details-page',
];

const investorValidationIds = ['investor-details', 'investor-details-page'];

const representedValidationIds = ['society-dashboard'];

const communicationsIds = [
  'com-certificate',
  'com-communication',
  'com-society',
];

const allAccessIds = ['signature-certificate'];

const boardValidationIds = ['board-partner', 'partner-delegation'];

const councilValidationIds = ['council-members'];

function isSuperAdmin(user) {
  return !!superAdmins.includes(user?.email);
}

function isAdmin(user, societyId) {
  if (user?.societies?.administrated?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.administrated?.includes(societyId))
      hasAccess = true;
  });
  return hasAccess;
}

function isPartner(user, societyId) {
  if (user?.societies?.participated?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.participated?.includes(societyId))
      hasAccess = true;
  });
  return hasAccess;
}

function isBeneficiary(user, societyId) {
  if (user?.societies?.beneficiated?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.beneficiated?.includes(societyId))
      hasAccess = true;
  });
  return hasAccess;
}

function isInvestor(user, societyId) {
  if (user?.societies?.invested?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.invested?.includes(societyId)) hasAccess = true;
  });
  return hasAccess;
}

function isRepresentant(user, societyId) {
  if (user?.societies?.represented?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.represented?.includes(societyId))
      hasAccess = true;
  });
  return hasAccess;
}

function isGuest(user, societyId) {
  if (user?.societies?.invited?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.invited?.includes(societyId)) hasAccess = true;
  });
  return hasAccess;
}

function isDirector(user, societyId) {
  if (user?.societies?.directed?.includes(societyId)) return true;
  const { usersWithAccess } = user;
  let hasAccess = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.societies?.directed?.includes(societyId)) hasAccess = true;
  });
  return hasAccess;
}

function representsPartner(user, partnerId) {
  if (user?.partners?.includes(partnerId)) return true;
  const { usersWithAccess } = user;
  let hasPartner = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.partners?.includes(partnerId)) hasPartner = true;
  });
  return hasPartner;
}

function representsBeneficiary(user, beneficiaryId) {
  if (user?.beneficiaries?.includes(beneficiaryId)) return true;
  const { usersWithAccess } = user;
  let hasBeneficiary = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.beneficiaries?.includes(beneficiaryId))
      hasBeneficiary = true;
  });
  return hasBeneficiary;
}

function representsInvestor(user, investorId) {
  if (user?.investors?.includes(investorId)) return true;
  const { usersWithAccess } = user;
  let hasInvestor = false;
  usersWithAccess?.forEach((currentUser) => {
    if (currentUser?.investors?.includes(investorId)) hasInvestor = true;
  });
  return hasInvestor;
}

function normalizeRoutePathname(url = '') {
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return url;
  }
  return url.slice(0, queryIndex);
}

function mergeRouteSearch(search = '', url = '') {
  if (search) {
    return search;
  }
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return '';
  }
  return url.slice(queryIndex);
}

function getBeneficiaryIdFromSearch(search = '') {
  return new URLSearchParams(search).get('beneficiaryId');
}

function shouldApplyBeneficiaryIncentivesMarketRestrictions(
  user,
  societyId,
  search
) {
  const beneficiaryId = getBeneficiaryIdFromSearch(search);

  if (
    beneficiaryId &&
    representsBeneficiary(user, beneficiaryId) &&
    isBeneficiary(user, societyId)
  ) {
    return true;
  }

  return isBeneficiary(user, societyId) && !isAdmin(user, societyId);
}

const incentivesMarketBeneficiaryOnlyAllowedRoutes = [
  'incentives-market-offers-list',
  'incentives-market-offers-list-beneficiary',
  'incentives-market-offer-details',
  'incentives-market-offer-operation-details',
  'incentives-market-my-operations',
];

function getIncentivesMarketBeneficiaryId(id, url, search) {
  if (id === 'incentives-market-offers-list-beneficiary') {
    const [, , , pathBeneficiaryId] = url.split('/');
    return pathBeneficiaryId || null;
  }

  return getBeneficiaryIdFromSearch(search);
}

function validateBeneficiaryOnlyIncentivesMarketAccess(user, id, url, search) {
  if (!incentivesMarketBeneficiaryOnlyAllowedRoutes.includes(id)) {
    return false;
  }

  const beneficiaryId = getIncentivesMarketBeneficiaryId(id, url, search);
  return Boolean(beneficiaryId) && representsBeneficiary(user, beneficiaryId);
}

function validateRoute(user, id, url, search = '') {
  if (!user || !id || !url) return false;

  if (superAdminIds.includes(id)) {
    return isSuperAdmin(user);
  }

  if (adminOrPartnerOrRepresentantValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return (
      isAdmin(user, societyId) ||
      isPartner(user, societyId) ||
      isRepresentant(user, societyId) ||
      isGuest(user, societyId)
    );
  }

  if (adminOrPartnerValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId) || isPartner(user, societyId);
  }

  const equityMarketValidationIds = [
    'equity-market',
    'equity-market-admin-panel',
    'equity-market-notifications',
    'equity-market-my-operations',
    'equity-market-trading-offers-list',
    'equity-market-trading-offers-list-partner',
    'equity-market-sell-trading-offers-list',
    'equity-market-buy-trading-offers-list',
    'equity-market-add-sell-trading-offer',
    'equity-market-add-buy-trading-offer',
    'equity-market-edit-sell-trading-offer',
    'equity-market-edit-buy-trading-offer',
    'equity-market-trading-offer-details',
    'equity-market-trading-offer-operation-details',
  ];
  if (equityMarketValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId) || isPartner(user, societyId);
  }

  const incentivesMarketValidationIds = [
    'incentives-market',
    'incentives-market-admin-panel',
    'incentives-market-notifications',
    'incentives-market-my-operations',
    'incentives-market-offers-list',
    'incentives-market-offers-list-beneficiary',
    'incentives-market-sell-offers-list',
    'incentives-market-buy-offers-list',
    'incentives-market-add-sell-offer',
    'incentives-market-add-buy-offer',
    'incentives-market-edit-sell-offer',
    'incentives-market-edit-buy-offer',
    'incentives-market-offer-details',
    'incentives-market-offer-operation-details',
  ];
  if (incentivesMarketValidationIds.includes(id)) {
    const normalizedPath = normalizeRoutePathname(url);
    const normalizedSearch = mergeRouteSearch(search, url);
    const [, , societyId] = normalizedPath.split('/');
    const hasBaseAccess =
      isAdmin(user, societyId) || isBeneficiary(user, societyId);

    if (!hasBaseAccess) {
      return false;
    }

    if (
      shouldApplyBeneficiaryIncentivesMarketRestrictions(
        user,
        societyId,
        normalizedSearch
      )
    ) {
      return validateBeneficiaryOnlyIncentivesMarketAccess(
        user,
        id,
        normalizedPath,
        normalizedSearch
      );
    }

    return true;
  }

  if (adminValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId);
  }

  if (otherAdminIds.includes(id)) {
    const societyId = url.split('/').pop();
    return isAdmin(user, societyId);
  }

  if (communicationsIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId);
  }

  if (partnerValidationIds.includes(id)) {
    const [, , societyId, partnerId] = url.split('/');
    return (
      isAdmin(user, societyId) ||
      (representsPartner(user, partnerId) && isPartner(user, societyId))
    );
  }

  if (investorValidationIds.includes(id)) {
    const [, , societyId, investorId] = url.split('/');
    return (
      isAdmin(user, societyId) ||
      (representsInvestor(user, investorId) && isInvestor(user, societyId))
    );
  }

  if (representedValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isRepresentant(user, societyId);
  }

  if (adminOrBeneficiaryValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId) || isBeneficiary(user, societyId);
  }

  if (adminOrInvestorValidationIds.includes(id)) {
    const [, , societyId] = url.split('/');
    return isAdmin(user, societyId) || isInvestor(user, societyId);
  }

  if (boardValidationIds.includes(id)) {
    const [, , societyId, , partnerId] = url.split('/');
    return (
      isAdmin(user, societyId) ||
      (representsPartner(user, partnerId) && isPartner(user, societyId)) ||
      isRepresentant(user, societyId)
    );
  }

  if (councilValidationIds.includes(id)) {
    const [, , societyId, ,] = url.split('/');
    return isAdmin(user, societyId) || isDirector(user, societyId);
  }

  // Special validations
  if (allAccessIds.includes(id)) {
    return true;
  }
  if (id === 'beneficiary-details') {
    const [, , societyId, , beneficiaryId] = url.split('/');
    return (
      isAdmin(user, societyId) ||
      (representsBeneficiary(user, beneficiaryId) &&
        isBeneficiary(user, societyId))
    );
  }
  if (id === 'beneficiary-sign') {
    // TODO Find out what to do here
    return true;
  }
  return true;
}
export default validateRoute;
